<div class="mapv2-sectors-container d-flex justify-content-center align-items-center" [style.zoom]="0.590" (window:resize)="onResize()">
    <canvas id="mapv2__sectors__canvas"></canvas>
    <img id="mapv2__sectors__img" usemap="#mapv2__sectors__map">
    <map name="mapv2__sectors__map"  id="mapv2__map"></map>
</div>
